module.exports = __webpack_public_path__ + "static/media/icon-analytics-1.32fbe04f.svg";